module.exports = __webpack_public_path__ + "assets/img/yixiangdan.841e5e8a.png";